import axios from 'axios';
import { GetURI } from '@/plugins/utilities';
import { SecurityController } from '@/plugins/securityController';
import { GetUserName } from './storageWars';
interface WebApiData {
    notify: boolean;
    message: string;
}

interface Note {
    icon: string;
    message: string;
}

class WebApi {
    public notify: boolean;
    public message: string;
    constructor(data: WebApiData) {
        this.notify = data.notify;
        this.message = data.message;
        this.init();
    }
    public init(): void {
        if (this.notify) {
            // if (this.notify_check()) {
            //     this.note();
            // }
            const i = 0;
        } else {
            this.log();
        }
    }
    private log(): void {
        axios.get(`${GetURI}/logit/${btoa(this.message)}`);
    }
    private notify_check(): boolean {
        try {
            Notification.requestPermission().then();
        } catch (e) {
            return false;
        }
        return true;
    }
}

export const LogIt = (message: string, isError: boolean) => {
    if(isError) {
        console.error(message);
    } else {
        console.log(message);
    }
}
